<template>
  <div class="service-utilize-container">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box" v-if="service">
          <admin-box-item title="서비스 정보" :useTab="false">
            <div class="columns">
              <div class="column is-6">
                <div class="grid-row">
                  <div class="grid-title">서비스명</div>
                  <div class="grid-content flex-align" style="gap:0 12px">
                    <div>{{ service.service_name }}</div>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">이용중인 상품</div>
                  <div class="grid-content">
                    <div v-for="(prod,pidx) in service.schedule.products" :key="`prod-${pidx}`"
                         style="text-align: left">[{{ prod.category_name }}] {{ prod.name }}</div>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">이용일</div>
                  <div class="grid-content flex-align" v-if="service.schedule">
                    <div>{{ datesFormat(service.schedule.start_date, 'date_3') }} ~
                      <span v-if="service.schedule.end_date && service.schedule.end_date !== ''">({{ datesFormat(service.schedule.end_date, 'date_3') }})</span></div>
                    <button v-if="service.schedule.end_date && service.schedule.end_date !== ''" class="button" style="margin-left:12px" @click="clickContinuous">이용기간 연장</button>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">다음 결제 예정일</div>
                  <div class="grid-content flex-align" v-if="service.schedule">
                    <div>{{ datesFormat(service.schedule.next_date, 'date_3') }}</div>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="grid-row-end">
                  <div class="grid-title">총 이용 금액</div>
                  <div class="grid-content">{{ service.total_price.utilize|currency }}</div>
                </div>
                <div class="grid-row-end">
                  <div class="grid-title">총 결제 금액</div>
                  <div class="grid-content">{{ service.total_price.account|currency }}</div>
                </div>
                <div class="grid-row-end">
                  <div class="grid-title">총 충전금</div>
                  <div class="grid-content">{{ service.total_price.charge|currency }}</div>
                </div>
                <div class="grid-row-end">
                  <div class="grid-title">충전금 사용 잔액</div>
                  <div class="grid-content">{{ service.total_price.charge_remain|currency }}</div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제 정보" :useTab="false">
            <div class="columns is-multiline">
              <div class="column is-full">
                <div class="grid-row">
                  <div class="grid-title">기간</div>
                  <div class="grid-content">
                    <div class="flex-between">
                      <div class="flex-align" style="gap:0 12px">
                        <admin-date-picker
                          :data.sync="filter.start_date"
                          @setDate="res => selDate('start_date', res)"></admin-date-picker>
                        <div>~</div>
                        <admin-date-picker
                          :data.sync="filter.end_date"
                          @setDate="res => selDate('end_date', res)"></admin-date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">제공 서비스 구분</div>
                  <div class="grid-content">
                    <select class="input-border" v-model="filter.category" style="width:130px">
                      <option v-for="(item,idx) in option.category" :key="`option-cat-${idx}`"
                              :value="item.value">{{ item.label }}</option>
                    </select>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">결제수단 구분</div>
                  <div class="grid-content">
                    <div class="flex-align" style="gap:0 12px">
                      <div class="check-box" v-for="(item,idx) in option.pay_method" :key="`pay-method-${idx}`">
                        <input :id="`pay-method-${idx}`" type="checkbox" @change="check(item)">
                        <label :for="`pay-method-${idx}`">{{ item.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">납부상태</div>
                  <div class="grid-content flex-between">
                    <div>
                      <select class="input-border" v-model="filter.status" style="width:130px">
                        <option v-for="(item,idx) in option.status" :key="`option-cat-${idx}`"
                                :value="item.value">{{ item.label }}</option>
                      </select>
                    </div>
                    <div>
                      <select class="input-border" v-model="page.page_length" style="width:130px" @change="onChangePageLength">
                        <option v-for="(item,idx) in option.pageLength" :key="`option-page-len-${idx}`"
                                :value="item.value">{{ item.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-full" style="padding-top:0 !important">
                <table>
                  <tr>
                    <th v-for="(item,idx) in header" :Key="`th-${idx}`" :style="`width:${item[1]}%`">{{ item[0] }}</th>
                  </tr>
                  <tr v-for="(item,idx) in list" :key="`tr-${idx}`">
                    <template v-if="item.editable"></template>
                    <template v-else>
                      <td>{{ item.index }}</td>
                      <td>{{ datesFormat(item.billing_date, 'date_3') }}</td>
                      <td>{{ item.category_name }}</td>
                      <td>{{ item.product_name }}</td>
                      <td>{{ item.product_price|currency }}</td>
                      <td>{{ item.account_price|currency }}</td>
                      <td>{{ item.pay_method_kor }}</td>
                      <td>{{ item.status_kor }}</td>
                      <td>{{ datesFormat(item.account_date, 'date_3') }}</td>
                    </template>
                  </tr>
                </table>
                <pagination ref="pagination" :total_page="page.total_page" @change="onPage"></pagination>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <modal-continuous ref="cModal" :service="service" @continue="onContinue"></modal-continuous>
  </div>
</template>

<script>

  import Pagination from "../../module/common/Pagination";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import ModalContinuous from "./components/ModalContinuous";
  export default {
    name: 'ServiceUtilize',
    components: {
      ModalContinuous,
      LpAdmDropInput,
      Pagination
    },
    created() {
      this.init();
    },
    watch: {
      filter: {
        handler() {
          this.page.cur_page = 1;
          this.getData();
        },
        deep: true
      }
    },
    data() {
      return {
        header: [
          ['index', 3],
          ['청구일', 9],
          ['제공 서비스 구분', 9],
          ['상품 내용', 22],
          ['상품 이용 금액', 11],
          ['결제(입금)액', 11],
          ['결제 수단 구분', 9],
          ['납부 상태', 9],
          ['결제일시', 9]
        ],
        filter: {
          start_date: '',
          end_date: '',
          pay_method: [],
          category: 0,
          status: -1
        },
        option: {
          service: [],
          pay_method: [
            {value: 0, label: '빌링결제(이니시스)', checked: false},
            {value: 1, label: '계좌이체', checked: false},
            {value: 2, label: '빌링결제(페이플)', checked: false},
            {value: 3, label: '충전금 소진', checked: false}
          ],
          category: [
            {value: 0, label: '전체'},
            {value: 1, label: '호스팅'},
            {value: 2, label: '충전'},
            {value: 3, label: '테마'},
            {value: 4, label: '추가개발진행'}
          ],
          status: [
            {value: -1, label: '전체'},
            {value: 0, label: '결제대기'},
            {value: 1, label: '결제완료'},
            {value: 2, label: '입금완료'}
          ],
          pageLength: [
            {value: 10, label: '10개씩 보기'},
            {value: 20, label: '20개씩 보기'},
            {value: 30, label: '30개씩 보기'},
            {value: 50, label: '50개씩 보기'},
            {value: 100, label: '100개씩 보기'}
          ]
        },
        service: undefined,
        page: {
          cur_page: 1,
          page_length: 10,
          total_page: 2
        },
        list: [],
      }
    },
    methods: {
      onContinue() {
        this.toast('이용기간이 정상적으로 연장되었습니다.');
        this.init();
      },
      clickContinuous() {
        this.$refs.cModal.open();
      },
      onChangePageLength() {
        this.page.cur_page = 1;
        this.getData();
      },
      selDate(type, value) {
        this.page.cur_page = 1;
        this.filter[type] = value;
      },
      onPage(res) {
        this.page.cur_page = res;
        this.getData();
      },
      async init() {
        let res_info = await this.$axios.get(this.getMasterUrl('utilize_info'));
        this.service = res_info.data;
        this.getData();
      },
      getMasterUrl(path) {
        return `${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/service/${this.$store.getters.masterService.service_id}/${path}`;
      },
      filter_valid(item, key) {
        if(item[key] === '' || item[key] === 0 || item[key] === -1 ||
          (Array.isArray(item[key]) && item[key].length() ===0)) {
          delete item[key];
        }
      },
      getData() {
        let params = this.cloneItem(this.filter);
        params.pay_method = params.pay_method.toString();
        this.filter_valid(params, 'category');
        this.filter_valid(params, 'start_date');
        this.filter_valid(params, 'end_date');
        this.filter_valid(params, 'pay_method');
        if(params.status === -1) {
          this.filter_valid(params, 'status');
        }
        params.page_num = this.page.cur_page;
        params.page_length = this.page.page_length;

        this.$axios.get(this.getMasterUrl('utilize'), {params: params}).then(res=>{
          this.list = res.data.data.map(item => {
            item.pay_method_kor = this.option.pay_method.filter(i => i.value === item.pay_method)[0].label;
            item.status_kor = this.option.status.filter(i => i.value === item.status)[0].label;
            return item;
          });
          this.page.total_page = res.data.total_page;
        });
      },
      check(item) {
        item.checked = !item.checked;
        this.filter.pay_method = this.option.pay_method.filter(i => i.checked).map(i => i.value);
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $background2=#f5f5f5
  $border-main=#dddddd
  $border-sub=#eeeeee
  $primary=#ff5722

  .grid-row
  .grid-row-end
    display grid
    grid-column-gap 8px
    font-size 14px
    margin-bottom 8px
    align-items center

  .grid-row
    grid-template-columns 120px 1fr

  .grid-row-end
    grid-template-columns 1fr 90px
    text-align right

  .grid-title
    font-weight 600

  .button
    width 110px

  .check-box
    input
      margin-right 4px
      vertical-align middle
      border 1px solid #dddddd

  .service-utilize-container
    table
      width 100%
      border 1px solid $border-main
      th
      td
        vertical-align middle
        text-align center
        border 1px solid $border-main
        padding 4px 8px
      th
        background-color $background2
</style>
<style lang="stylus">
  .lp-date-picker
    margin-bottom 0 !important
  .mx-datepicker
    width 130px
  .title-group
    margin-bottom 12px !important
</style>
